import React from 'react'
import { useSelector, useEffect, useLocation } from 'hooks'
import { Route, Switch, Redirect } from 'react-router-dom'
import { hot } from 'react-hot-loader'

import App from './App/App'
import GuestApp from './GuestApp/GuestApp'
import DeleteSuccess from './DeleteSuccess'
import Labels from './Labels'
import Logout from './Logout/Logout'
import Payment from './Payment/Payment'
import Error from './Error'
import RegistrationConfirmation from './RegistrationConfirmation'

const routes = [
  { to: '/logout', component: Logout },
  { to: '/delete/success', component: DeleteSuccess },
  { to: '/payment/(upgrade|success|error)', component: Payment },
  { to: '/labels', component: Labels }, // meant for devs only, lazy loaded
  { to: '/', component: App },
]

const Routes = () => {
  const { pathname } = useLocation()
  const siteName = useSelector(s => s.siteConfig.siteName)
  const deleted = useSelector(s => s.account?.deleted)
  const guest = useSelector(s => !!s.myProfile.error)

  useEffect(() => {
    document.title = siteName
  }, [])

  if (pathname.includes('/error')) return <Error />

  if (pathname.includes('/contacts')) return <Redirect to="/faq" />

  if (pathname.includes('/delete/success')) return <DeleteSuccess />

  if (pathname.includes('/registration/confirmation')) return <RegistrationConfirmation />

  if (deleted) return <Redirect to="/delete/success" />

  if (guest) return <GuestApp />

  return (
    <Switch>
      {routes.map(r => (
        <Route key={r.to} path={r.to} component={r.component} />
      ))}
    </Switch>
  )
}

export default hot(module)(Routes)
